<template>
  <v-form @submit.prevent="submit">
    <v-text-field
      v-model="place.name"
      label="Nome"
      :error-messages="error.name || ''"
      required
    ></v-text-field>
    <v-text-field
      v-model="place.building"
      label="Sede"
      :error-messages="error.building || ''"
      required
    ></v-text-field>
    <v-textarea
      v-model="place.address"
      label="Indirizzo"
      :error-messages="error.address || ''"
      required
    ></v-textarea>
    <v-text-field
      v-model="place.order"
      type="number"
      label="Rank ordinamento"
      :error-messages="error.order || ''"
      required
    ></v-text-field>
    <v-textarea
      v-model="place.notes"
      label="Note"
      :error-messages="error.notes || ''"
    ></v-textarea>
    <form-actions :loading="loading" @undo="reset" @submit="submit" />
  </v-form>
</template>

<script>
import { cloneDeep } from "@/lodash"

export default {
  props: {
    withData: {
      type: Object,
      default: () => ({}),
    },
    error: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      place: {},
    }
  },
  watch: {
    withData: {
      handler: "reset",
      deep: true,
    },
  },
  methods: {
    reset() {
      this.place = cloneDeep(this.withData)
    },
    submit() {
      this.$emit("submit", this.place)
    },
  },
}
</script>
